import './style/index.less';
import PluginInstall from './PluginInstall';

export * from './PluginInstall';
export default PluginInstall;
